<template>
  <div v-if="videoFrequency[0]">
    <!--    <video class="markdown-player"
                :src="url"
                width="100%" height="809" style="z-index: 1">
        </video>-->
    <video controls ref="videoRef" preload width="100%" height="809"  style="z-index: 3">
      <source :src="'upload/video/'+videoFrequency[0].videoUrl+'.mp4'" type="video/mp4"/>
    </video>
    <div style="position: absolute;width: 1440px;height: 807px;margin-top: -813px;" v-show="this.bgShow">
      <img :src="videoFrequency[0].videoPictureUrl" style="width: 100%;height: 100%" ref="videoPic">
    </div>
    <div v-show="this.buttonShow">
      <button class="el-icon-video-play"
              style="position: absolute;margin-top: -500px;margin-left: 630px;font-size: 150px;color: white"
              @click="playVideo"></button>
    </div>
    <div class="allVideoFrequency">
      <span style="font-size: 25px;color:chocolate;position: absolute;"> 影像志作品集 :</span>
      <ul>
        <li v-for="(item,index) in allVideoFrequency" :key="index" @click="changeVideoUrl(item)"  style="margin-left: 30px">
          {{ item.videoText }}
        </li>
      </ul>
    </div>
    <div class="worksVideoFrequency" @mouseover="videoFrequencyFlag=true" @mouseleave="videoFrequencyFlag=false">
      <div  v-show="videoFrequencyFlag" class="worksVideoFrequency-d">
        <span style="font-size: 20px;color:chocolate;margin-left: 20px">本卷影像志关联作品集:</span>
      <ul>
        <li v-for="(item,index) in videoFrequency" :key="index" @click="changeVideoUrl(item)">
          {{ (index+1)+'.'+item.videoText }}
        </li>
      </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'EiBPlayer',
  data() {
    return {
      bgShow: true,
      buttonShow: true,
      videoFrequencyFlag: false,
      number:0,
      isFlag:false,
    }
  },
  props: {
    videoFrequency: {
      type: Array,
      required: true
    },
    allVideoFrequency: {
      type: Array,
      required: true
    },
  },
  created() {

  },
  mounted() {
   /* console.log('xxxxxxxxxxxxxxxxxxxxxxxxx')
    console.log(this.flag)
    if (this.flag){
      this.$refs.videoRef.play()
    }*/
  },
  methods: {
    playVideo() {
      this.$refs.videoRef.play()
      this.bgShow = false
      this.buttonShow = false
      this.isFlag=true
    },
    changeVideoUrl(item) {
      this.isFlag=false
      this.$refs.videoRef.pause()
      this.bgShow = true
      this.buttonShow = true
      this.$refs.videoRef.src = 'upload/video/' + item.videoUrl+'.mp4'
      this.$refs.videoPic.src = item.videoPictureUrl
    }
  },
}
</script>

<style scoped lang="scss">
@import "../eiuov-ui/css/ei-font.css";

.font-test {
  /*font-family: XiaXingKai;*/
  font-family: CaoShuFanTi;
  font-size: 40px;
}

.worksVideoFrequency {
  position: absolute;
  width: 1440px;
  height: 80px;
  margin-top: -123px;
  margin-left: 60px;
  color: white;
  opacity: 0.9;
  z-index:1;
}
.worksVideoFrequency-d{
  letter-spacing: 5px;
  font-weight: bolder;
  font-size: 20px;
  ul {
    line-height: 50px;
  }

  li {
    margin-left: 20px;
    float: left; /* 往左浮动 */
    cursor: pointer;
  }
}
.allVideoFrequency {
  position: absolute;
  width: 1440px;
  height: 60px;
  margin-top: 7px;
  padding-top: 5px;
  border: 5px solid #db0934;
  background-color: #05c4f3;
  border-radius: 10px;

  ul {
    margin-left: 150px;
    font-size: 20px;
    line-height: 30px;
    font-family: SimHei;
  }

  li {
    letter-spacing: 2px;
    list-style: none; /* 将默认的列表符号去掉 */
    padding: 3px; /* 将默认的内边距去掉 */
    float: left; /* 往左浮动 */
    display: block;
    cursor: pointer;
    color: white;
    border-radius: 5px;
    border: 2px solid #ba8b00;
    background-color: #b61a2e;

  }
}
</style>
